import { render, staticRenderFns } from "./HrApproval.vue?vue&type=template&id=44a9d240"
import script from "./HrApproval.vue?vue&type=script&lang=js"
export * from "./HrApproval.vue?vue&type=script&lang=js"
import style1 from "./HrApproval.vue?vue&type=style&index=1&id=44a9d240&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports